module.exports = __webpack_public_path__ + "static/media/goods_icon.cd1a1e19.svg";